import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useContext, useState } from 'react';
import { Form } from '@applyboard/ui-components';
import { useOnboardingFormControllerContext } from "../../../controller/OnboardingFormController";
import { Content } from "./Content";
import { storeIntakesValue, getStoredIntakes, deleteStoredIntakes } from "../../storage/Intakes/localStorage";
import { LoadingOverlay } from "../../../../ab-common-legacy/LoadingOverlay";
import { useDeleteStudentPreferences, useEditStudentPreferences, useStudentPreferences } from "../../../../data/studentPreferences";
import { useIntakes } from "../../../../data/intakes";
import { useAppContext } from "../../../CEF/Providers";
import { FormStateContext } from "../../../FormStateProvider";
import { useSearchUrl } from "../../../../hooks/useSearchUrl";
import { goToSearchPage } from "../../../../helpers";
import { useSearchParams } from "../../../../hooks/useSearchParams";
export var IntakesPage = function IntakesPage() {
  var searchUrl = useSearchUrl();
  var params = useSearchParams();
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    selectedIntakes = _useState2[0],
    setSelectedIntakes = _useState2[1];
  var _useAppContext = useAppContext(),
    userId = _useAppContext.userId;
  userId = userId ? userId.toString() : null;
  var _useOnboardingFormCon = useOnboardingFormControllerContext(),
    handlePassed = _useOnboardingFormCon.handlePassed,
    handleSkipped = _useOnboardingFormCon.handleSkipped,
    handleError = _useOnboardingFormCon.handleError;
  var _useContext = useContext(FormStateContext),
    onShowError = _useContext.onShowError;
  var _useIntakes = useIntakes(),
    options = _useIntakes.intakesData,
    isLoadingIntakesData = _useIntakes.isLoadingIntakesData;
  var _useStudentPreference = useStudentPreferences(userId, {
      enabled: Boolean(userId)
    }),
    studentPreferences = _useStudentPreference.studentPreferences,
    isLoadingStudentPreferences = _useStudentPreference.isLoadingStudentPreferences;
  var _useEditStudentPrefer = useEditStudentPreferences(userId, 'intakes'),
    editStudentPreferences = _useEditStudentPrefer.editStudentPreferences;
  var _useDeleteStudentPref = useDeleteStudentPreferences(userId, 'intakes'),
    deleteStudentPreferences = _useDeleteStudentPref.deleteStudentPreferences;
  if (isLoadingIntakesData || isLoadingStudentPreferences && userId) {
    return /*#__PURE__*/React.createElement(LoadingOverlay, {
      "aria-label": "Loading"
    });
  }
  var signedInSubmit = function signedInSubmit(selectedFields) {
    var data = {
      values: selectedFields,
      type: 'intakes'
    };
    editStudentPreferences(data, {
      onSuccess: function onSuccess() {
        var selectedIntakeNames = selectedFields.map(function (intake) {
          var _options$flatMap$find, _options$flatMap$find2;
          return (_options$flatMap$find = (_options$flatMap$find2 = options.flatMap(function (year) {
            return year.children;
          }).find(function (option) {
            return option.name === intake;
          })) === null || _options$flatMap$find2 === void 0 ? void 0 : _options$flatMap$find2.label) !== null && _options$flatMap$find !== void 0 ? _options$flatMap$find : intake;
        });
        handlePassed({
          values: selectedIntakeNames
        });
      },
      onError: function onError() {
        onShowError();
        handleError();
      }
    });
  };
  var intakesSubmit = function intakesSubmit() {
    if (userId) {
      signedInSubmit(selectedIntakes);
    } else {
      goToSearchPage({
        searchParams: params,
        searchUrl: searchUrl
      });
      var selectedIntakeNames = selectedIntakes.map(function (intake) {
        var _options$flatMap$find3, _options$flatMap$find4;
        return (_options$flatMap$find3 = (_options$flatMap$find4 = options.flatMap(function (year) {
          return year.children;
        }).find(function (option) {
          return option.name === intake;
        })) === null || _options$flatMap$find4 === void 0 ? void 0 : _options$flatMap$find4.label) !== null && _options$flatMap$find3 !== void 0 ? _options$flatMap$find3 : intake;
      });
      handlePassed({
        values: selectedIntakeNames
      });
    }
  };
  var handleIntakeChange = function handleIntakeChange(intakes) {
    storeIntakesValue(intakes);
    setSelectedIntakes(intakes);
  };
  var skipSubmit = function skipSubmit() {
    if (userId) {
      deleteStudentPreferences(undefined, {
        onSuccess: function onSuccess() {
          handleSkipped();
        },
        onError: function onError() {
          onShowError();
          handleError();
        }
      });
    } else {
      deleteStoredIntakes();
      handleSkipped();
      goToSearchPage({
        searchParams: params,
        searchUrl: searchUrl
      });
    }
  };
  var defaultValues = {
    intakes: userId ? studentPreferences.intakes : getStoredIntakes()
  };
  return /*#__PURE__*/React.createElement(Form, {
    onSubmit: function onSubmit() {
      return intakesSubmit();
    },
    defaultValues: defaultValues,
    onSubmitError: handleError
  }, /*#__PURE__*/React.createElement(Content, {
    options: options,
    skipSubmit: skipSubmit,
    defaultValues: defaultValues,
    handleIntakeChange: handleIntakeChange
  }));
};